import React from "react";
import Joi from "joi-browser";
import Form from "../Comman/Form";
import SecurityQuestion from "./SecurityQuestion";
import http from "../../Services/httpService";
import config from "../../config.json";
import ThankYou from "./ThankYou";

class ForgotPwd extends Form {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      errors: {},
      securityQuestion: false,
      pwdBlock: true,
      userTypes: [],
      secQuestion: "",
      emailAuth: false,
      phoneAuth: false,
      securityAuth: false,
      thankYou: false,
      questionAuth: false,
      sendCodeBtnLoding: false,
      verifyBtnLoding: false,
      reSendCodeBtnLoding: false,
      reSendCodeMsg: false,
    };
  }

  schema = {
    //username: Joi.string().required().label("User Name"),
    //userType: Joi.string().required().label("User Type"),
    email: Joi.string().email().required().label("Email"),
  };

  handleSecurityQuestion = (question) => {
    this.setState({
      securityQuestion: true,
      pwdBlock: false,
      secQuestion: question,
    });
  };

  handleQuestionBack = () => {
    this.setState({
      securityQuestion: false,
      questionAuth: true,
      pwdBlock: true,
    });
  };

  doSubmit = async () => {
    const { data, errors } = this.state;
    const { data: result } = await http.post(config.VerifyUserByUserName, data);
    if (result !== null && result !== "") {
      this.handleSecurityQuestion(result);
    } else {
      errors["username"] = "Invalid Details";
      this.setState({ errors });
    }
  };

  handleEmailAuth = () => {
    this.setState({ emailAuth: true, phoneAuth: false, errors: {}, data: {} });
  };
  handlePhoneAuth = () => {
    this.setState({ phoneAuth: true, emailAuth: false, errors: {}, data: {} });
  };
  handleSecurityCode = async () => {
    const { data, emailAuth, phoneAuth, errors } = this.state;
    const { forgotType } = this.props;
    if (data["userName"] === "" || data["userName"] === undefined) {
      errors["userName"] = "Please enter username";
      this.setState({ errors });
    } else if (
      data["email"] === "" ||
      (data["email"] === undefined && emailAuth)
    ) {
      errors["email"] = "Please enter email";
      this.setState({ errors });
    } else if (
      data["phone"] === "" ||
      (data["phone"] === undefined && phoneAuth)
    ) {
    } else {
      this.setState({ sendCodeBtnLoding: true });
      if (emailAuth && !phoneAuth) {
        const { data: result } = await http.get(
          config.SendSecurityCodeToEmail +
          data["userName"] +
          "&email=" +
          data["email"] +
          "&type=" +
          forgotType
        );

        if (result === "fail") {
          errors["email"] = "Invalid Details";
          this.setState({ errors, sendCodeBtnLoding: false });
        } else {
          this.setState({ securityAuth: true, sendCodeBtnLoding: false });
        }
      }

      if (phoneAuth && !emailAuth) {
        const { data: result } = await http.get(
          config.SendSecurityCodeToPhone +
          data["userName"] +
          "&phone=" +
          encodeURIComponent(data["phone"]) +
          "&type=" +
          forgotType
        );

        if (result === "fail") {
          errors["phone"] = "Invalid Details";
          this.setState({ errors });
        } else {
          this.setState({ securityAuth: true, sendCodeBtnLoding: false });
        }
      }
    }
  };
  handleVerifyCode = async () => {
    const { data, errors, emailAuth, phoneAuth } = this.state;
    if (data["securityCode"] === "" || data["securityCode"] === undefined) {
      errors["securityCode"] = "Please enter security code";
      this.setState({ errors });
    } else {
      this.setState({ verifyBtnLoding: true });
      let email = data["email"];
      if (phoneAuth) email = data["phone"];
      const { data: result } = await http.get(
        config.VerifySecurityCode +
        email +
        "&code=" +
        data["securityCode"] +
        "&type=pwd"
      );
      if (result === "success") {
        this.setState({
          thankYou: true,
          pwdBlock: false,
          verifyBtnLoding: true,
          errors: {},
        });
      } else {
        errors["securityCode"] = "Invalid Code";
        this.setState({ errors, verifyBtnLoding: false });
      }
    }
  };
  handleQuestionAuth = () => {
    this.setState({
      questionAuth: true,
      emailAuth: false,
      phoneAuth: false,
      data: {},
    });
  };

  handleBack = () => {
    const { emailAuth, phoneAuth, questionAuth, securityAuth } = this.state;
    if (!securityAuth && emailAuth) {
      this.setState({
        emailAuth: !emailAuth,
      });
    }
    if (!securityAuth && phoneAuth) {
      this.setState({
        phoneAuth: !phoneAuth,
      });
    }
    if (!securityAuth && questionAuth) {
      this.setState({
        questionAuth: !questionAuth,
      });
    }

    if (emailAuth || phoneAuth || questionAuth)
      this.setState({
        securityAuth: false,
      });
    else this.props.handlePwdBack();
  };

  handleResendCode = async () => {
    const { data, emailAuth, phoneAuth, errors } = this.state;
    const { forgotType } = this.props;
    this.setState({ reSendCodeBtnLoding: true });
    if (emailAuth && !phoneAuth) {
      const { data: result } = await http.get(
        config.SendSecurityCodeToEmail +
        data["userName"] +
        "&email=" +
        data["email"] +
        "&type=" +
        forgotType
      );
      if (result === "fail") {
        errors["email"] = "Invalid Details";
        this.setState({
          errors,
          reSendCodeBtnLoding: false,
          reSendCodeMsg: false,
        });
      } else {
        this.setState({
          reSendCodeBtnLoding: false,
          reSendCodeMsg: true,
        });
      }
    }

    if (phoneAuth && !emailAuth) {
      const { data: result } = await http.get(
        config.SendSecurityCodeToPhone +
        data["userName"] +
        "&phone=" +
        encodeURIComponent(data["phone"]) +
        "&type=" +
        forgotType
      );
      if (result === "fail") {
        errors["phone"] = "Invalid Details";
        this.setState({
          errors,
          reSendCodeBtnLoding: false,
          reSendCodeMsg: false,
        });
      } else {
        this.setState({ reSendCodeBtnLoding: false, reSendCodeMsg: true });
      }
    }
  };

  render() {
    const {
      pwdBlock,
      securityQuestion,
      secQuestion,
      userTypes,
      data,
      emailAuth,
      phoneAuth,
      securityAuth,
      thankYou,
      questionAuth,
      sendCodeBtnLoding,
      verifyBtnLoding,
      reSendCodeBtnLoding,
      reSendCodeMsg,
    } = this.state;
    const { handlePwdBack, urlData, forgotType } = this.props;
    return (
      <React.Fragment>
        {pwdBlock && (
          <div className="row">
            <div className="form-group col-md-12">
              <button className="btn btn-link pl-0" onClick={this.handleBack}>
                <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
                Back
              </button>
            </div>

            {questionAuth && (
              <React.Fragment>
                <div className="col-md-12">
                  {this.renderInput("username", "Enter Your Username")}
                </div>
                <div className="col-md-12">
                  {this.renderInput("email", "Enter Your Registered Email")}
                </div>
                <div className="col-md-12">
                  <button
                    className="btn btn-outline-default w-100"
                    disabled={this.validate()}
                    onClick={this.handleSubmit}
                  >
                    Next
                  </button>
                </div>
              </React.Fragment>
            )}

            {!emailAuth && !phoneAuth && !questionAuth && (
              <div className="col-md-12 text-center">
                <h2 className="mb-3">Verify Your Identity</h2>
                <p>
                  You will now be required to enter One-Time Security Code to
                  verify your identity.
                </p>
                <br />
                <h5>How would you like to receive the code?</h5>
                <br />
                <button
                  className="btn btn-outline-default"
                  onClick={this.handleEmailAuth}
                >
                  Send To My Email
                </button>
                {/* <button
                  className="btn btn-outline-default"
                  onClick={this.handlePhoneAuth}
                >
                  Text To My Mobile
                </button> */}
                <button
                  className="btn btn-outline-default"
                  onClick={this.handleQuestionAuth}
                >
                  Security Question
                </button>
              </div>
            )}
            {(emailAuth || phoneAuth) && (
              <div className="col-md-12">
                {this.renderInput("userName", "Enter Your Username")}
              </div>
            )}
            {emailAuth && (
              <div className="col-md-12">
                {this.renderInput("email", "Enter Your Registered Email")}
              </div>
            )}
            {/* {phoneAuth && (
              <div className="col-md-12">
                {this.renderInput(
                  "phone",
                  "Enter Your Registered Mobile Number"
                )}
              </div>
            )} */}
            {securityAuth && (
              <div className="col-md-12">
                {this.renderInput(
                  "securityCode",
                  "Enter your code below to continue"
                )}
              </div>
            )}
            {(emailAuth || phoneAuth) && !securityAuth && (
              <div className="col-md-12 text-center">
                <button
                  className="btn btn-outline-default"
                  disabled={sendCodeBtnLoding}
                  onClick={this.handleSecurityCode}
                >
                  {sendCodeBtnLoding && (
                    <i className="fa fa-refresh fa-spin mr-2"></i>
                  )}
                  Send Security Code To My {emailAuth && " email"}
                  {phoneAuth && " mobile"}
                </button>
              </div>
            )}
            {securityAuth && (
              <div className="col-md-12 text-center">
                <button
                  className="btn btn-outline-default"
                  disabled={verifyBtnLoding}
                  onClick={this.handleVerifyCode}
                >
                  {verifyBtnLoding && (
                    <i className="fa fa-refresh fa-spin mr-2"></i>
                  )}
                  Verify
                </button>
                <br />
                <br />
                <p>Didn't receive the code?</p>
                <button
                  className="btn btn-sm btn-link pl-0"
                  disabled={reSendCodeBtnLoding}
                  onClick={this.handleResendCode}
                >
                  {reSendCodeBtnLoding && (
                    <i className="fa fa-refresh fa-spin mr-2"></i>
                  )}
                  Resend Code
                </button>
                {reSendCodeMsg && (
                  <span className="text-black">
                    Security Code Sent Successfully
                  </span>
                )}
              </div>
            )}
          </div>
        )}
        {thankYou && <ThankYou forgotType="pwd" urlData={urlData}></ThankYou>}
        {securityQuestion && (
          <SecurityQuestion
            handleQuestionBack={this.handleQuestionBack}
            secQuestion={secQuestion}
            userType={data["userType"]}
            forgotType="pwd"
            urlData={urlData}
          ></SecurityQuestion>
        )}
      </React.Fragment>
    );
  }
}

export default ForgotPwd;
